// extracted by mini-css-extract-plugin
export var standaloneTable = "_1t-0";
export var standaloneTableWithBodyFill = "_1t-1";
export var withExtraHeader = "_1t-2";